module.exports = __webpack_public_path__ + "static/assets/6e5f0c1dfed36a77dd88859418af49f2.svg";